import {
  Box,
  Container,
  Typography,
  Alert,
  CardHeader,
  Button,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { formatAmountInCurrency } from '../utils';
import {
  CreditCardOffTwoTone,
  CreditCardTwoTone,
  LoyaltyTwoTone,
  WalletTwoTone,
} from '@mui/icons-material';

export const ResultPage = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { token } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const success = searchParams.get('status') === 'SUCCESS';
  const description = searchParams.get('description');
  const amount = searchParams.get('amount');
  const loyaltyAmount = searchParams.get('loyaltyAmount');
  const loyaltyPoints = searchParams.get('loyaltyPoints');
  const currencyCode = searchParams.get('currencyCode') as string;

  return (
    <Container>
      <Card sx={{ mt: 4 }}>
        <CardHeader
          title={
            success ? t('resultPage.successTitle') : t('resultPage.failTitle')
          }
          subheader={
            <Typography variant="body2">
              {success
                ? t('resultPage.successMsg')
                : t('resultPage.failureMsg')}
            </Typography>
          }
        />
        <CardContent>
          {!success ? (
            <Alert variant="outlined" severity={success ? 'success' : 'error'}>
              {description}
            </Alert>
          ) : (
            <List>
              {loyaltyPoints && (
                <ListItem>
                  <ListItemIcon>
                    <LoyaltyTwoTone />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      loyaltyAmount && currencyCode
                        ? t('resultPage.usedPointsWithAmount', {
                            fiat: formatAmountInCurrency(
                              parseFloat(loyaltyAmount),
                              currencyCode,
                            ),
                            points: parseFloat(loyaltyPoints),
                          })
                        : t('resultPage.usedPoints', {
                            points: parseFloat(loyaltyPoints),
                          })
                    }
                    secondary={t('resultPage.usedLoyaltyPoints')}
                  />
                </ListItem>
              )}
              {amount && currencyCode && (
                <ListItem>
                  <ListItemIcon>
                    <CreditCardTwoTone />
                  </ListItemIcon>
                  <ListItemText
                    secondary={t('resultPage.debitedFromCC')}
                    primary={formatAmountInCurrency(
                      parseFloat(amount),
                      currencyCode,
                    )}
                  />
                </ListItem>
              )}
              {(amount || loyaltyAmount) && (
                <ListItem>
                  <ListItemIcon>
                    <WalletTwoTone />
                  </ListItemIcon>
                  <ListItemText
                    primary={formatAmountInCurrency(
                      0 + Number(amount || 0) + Number(loyaltyAmount || 0),
                      currencyCode,
                    )}
                    secondary={t('resultPage.subtotal')}
                  />
                </ListItem>
              )}
            </List>
          )}
        </CardContent>
        <CardActions>
          <Button component={Link} to="/" variant="text" color="inherit">
            {t('resultPage.backHome')}
          </Button>

          {success ? (
            <Button
              component={Link}
              variant={'contained'}
              color={'primary'}
              to={token ? '/account/orders' : '/login-without-account'}
            >
              {t('resultPage.newPayment')}
            </Button>
          ) : (
            <Button onClick={() => nav('/login')} variant="contained">
              {t('resultPage.retry')}
            </Button>
          )}
        </CardActions>
      </Card>
    </Container>
  );
};
